module.exports = __webpack_public_path__ + "static/media/game-endgame.cb355375.png";